import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en.json';
import itTranslation from './locales/it.json';

export const resources = {
	it: {
		translation: itTranslation
	},
	en: {
		translation: enTranslation
	}
};

i18n
	//.use(LanguageDetector)
	.use(initReactI18next)
	.init(
		{
			resources,
			supportedLngs: ['it', 'en'],
			fallbackLng: 'it',
			lng: 'it', // Forzatura in It di default
			debug: true
		},
		(error) => {
			if (error) {
				console.error('Error loading translations: ', error);
			}
		}
	);

export default i18n;
